import React, { useState } from 'react';
import { useSelector } from 'react-redux';

const useAdmin = () => {
   const {user} = useSelector(state => state.auth);

   if(user?.role === 'admin'){
      return true;
   }
   return false

};

export default useAdmin;